import React from 'react';
import $ from 'jquery';
import {GetParams, MWBaseURL} from './../Utilities.js'
import {createApiClient} from "../api/ApiClient";

class TagFilter extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			tag: null,
			tagAndMode: false,

			needToUpdate: false,
			updateCount: 0,
			id: "tagFilter",
      isDropdownOpen: false
		};
    this.selectRef = React.createRef();
	}

	static getDerivedStateFromProps(props, state) {
		if(state.date !== props.date || state.dateEnd !== props.dateEnd || state.tag !== props.tag || state.updateCount !== props.updateCount){
			return {...props, needToUpdate: true}
		}
		return {...props};
	}

	componentDidUpdate(props, state){
		let self = this
		if(this.state.needToUpdate && !this.state.isDropdownOpen){
			this.setState({needToUpdate: false}, function(){
				self.load()
			})
		}
	}

	componentDidMount() {
		this.load()
    $(this.selectRef.current).on('show.bs.select', () => {
      this.setState({ isDropdownOpen: true });
    });

    $(this.selectRef.current).on('hide.bs.select', () => {
      this.setState({ isDropdownOpen: false });
    });
	}

	setFilterValue = (e) => {
		let self = this
		let val = Array.from(e.target.selectedOptions, option => option.value);
		self.setState({tag: val}, function(){
			self.state.refilter({
				selectedTag: val
			})
		})
	}

	setOrMode = () => {
		this.state.refilter({
			tagAndMode: false
		})
	}

	setAndMode = () => {
		this.state.refilter({
			tagAndMode: true
		})
	}

	clearFilter = () => {
		let self = this
		self.setState({tag: []}, function(){
			self.state.refilter({
				selectedTag: []
			})
		})
	}

	load(){
		let self = this
		const apiClient = createApiClient();
		apiClient.get(MWBaseURL()+"tag_list?"+GetParams(self.state))
		.then(data => {
				$("#"+self.state.id+" option").remove()
				data.forEach(function(item, index){
					$("#"+self.state.id).append('<option>'+item.tag+'</option>');
				})
				$("#"+self.state.id).selectpicker('val', self.state.tag).selectpicker('refresh');
			}).catch(e => console.log(e));
	}

	render(){
		return (
			<div className="col-lg-2 col-md-3 col-sm-4 pt-1">
				<div className="btn-group" style={{"width": "90%"}}>
					<div className="btn-group dropleft" role="group">
						<button type="button" className="btn btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<span className="sr-only">Toggle Dropleft</span>
						</button>
						<div className="dropdown-menu">
							<h6 className="dropdown-header">Toggle mode</h6>
							<button className={"dropdown-item"+(!this.state.tagAndMode ? " active" : "")} onClick={this.setOrMode}>OR&nbsp;
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
									<title>All trades that include at least one of the selected tags.</title>
									<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
									<path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
								</svg>
							</button>
							<button className={"dropdown-item"+(this.state.tagAndMode ? " active" : "")} onClick={this.setAndMode}>AND&nbsp;
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
									<title>Show all of the trades for a symbol on a particular date if all of these tags are used at least once (e.g. "Show me all of my trades on a given symbol where I used my IPO tag at least once AND my Capitulation tag at least once")</title>
									<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
									<path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
								</svg>
							</button>
						</div>
					</div>
					<div className="input-group">
						<select ref={this.selectRef} className="selectpicker form-control" id={this.state.id} onChange={this.setFilterValue} title="Filter Tags" data-live-search="true" data-actions-box="true" data-size="10" multiple></select>
						<div className="input-group-append">
							<button className="btn btn-outline-secondary clear-btn" type="button" onClick={this.clearFilter}><img src="icon.png" alt="X"/></button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}
export default TagFilter;